module.exports = __webpack_public_path__ + "static/img/image023.0aff199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image023.png
// module id = DM3v
// module chunks = 1